export default "__VITE_ASSET__3e874dce__"